module.exports = __webpack_public_path__ + "media/V11.b8708810.mp4";